import axios from 'axios';
import { getEnvironmentConfig } from '@/modules';

const DEAKIN_DOMAIN = '@deakin.edu.au';

export function isDeakinEmail(email) {
  return (
    typeof email === 'string' &&
    email.toLowerCase().endsWith(DEAKIN_DOMAIN)
  );
}

export async function requestPasswordReset(email) {
  const serverUrl = getEnvironmentConfig('serverUrl');
  return axios.post(`${serverUrl}/public/request-password-reset`, {
    email,
  });
}
